import template from './separate-wcs-count.jade';

export default angular
  .module('cian.addForm.separateWcsCount', [])
  .directive('cianAfAboutObjectSeparateWcsCount', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller(deviceService) {
      'ngInject';

      this.isMobile = deviceService.isMobile;

      this.items = [
        {
          value: undefined,
          text: 'Нет',
        },
        ...[1, 2, 3, 4].map(n => ({ value: n, text: n })),
      ];

      if (!this.ad.separateWcsCount) {
        this.ad.separateWcsCount = this.items[0].value;
      }
    },
    controllerAs: 'separateWcsCount',
    template,
  })).name;
